import { render, staticRenderFns } from "./OperationsResourceList.vue?vue&type=template&id=27511258&scoped=true"
import script from "./OperationsResourceList.vue?vue&type=script&lang=js"
export * from "./OperationsResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27511258",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27511258')) {
      api.createRecord('27511258', component.options)
    } else {
      api.reload('27511258', component.options)
    }
    module.hot.accept("./OperationsResourceList.vue?vue&type=template&id=27511258&scoped=true", function () {
      api.rerender('27511258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resourceManager/OperationsResourceList.vue"
export default component.exports